import { useMemo, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Form } from "react-bootstrap";
import { Slider, Flex, Progress } from "antd";
import type { SliderSingleProps } from "antd";
import { MESSAGE } from "../../../../utils/message";
import GreyBox from "../../../../assests/images/grey-message-box.svg";
import GreyHeart from "../../../../assests/images/grey-heart-box.svg";
import GreyBackgroundBox from "../../../../assests/images/grey-background-box.svg";
import {
  SectionTitle,
  Title,
  VoterWatchWrapper,
  VoterWatchBox,
  FoundationBox,
  FoundationImage,
  FoundationContent,
  FoundationSubTitle,
  ButtonSection,
  VoterWatchButton,
  AddressHere,
  NonprofitsStatsGroup,
  NonprofitsStats,
  NonprofitsStatsText,
  NonprofitsStatsSpan,
  ReviewCounter,
  ReviewCounterList,
  TextSpan,
  ReviewCounterText,
  ReviewListImage,
  LinkingText,
  RangeNonprofitStats,
  ReviewTextNumber,
  ReviewTextNumberSpan,
  ProfileCompletionBox,
  ProfileCompletionProgressBar,
  ProfileCompletionCheckBox,
  CheckBoxLabelGroup,
  FormCheckboxText,
  FormCheckboxLink,
  ProfileCheckboxList,
  RatingHD,
} from "./manageMyNonprofitStatsStyle";
import MailAddressConfirmationModal from "../../modal/mailAddressConfirmationModal";
import NoImage from "../../../../assests/images/gnp_noimg.png"
import { useDispatch, useSelector } from "react-redux";
import {
  confirmAddressHandler,
  nonprofitStatsHandler,
} from "../../../../redux/slices/myNonprofit/nonprofitStats-slice";
import moment from "moment";
import { CardRatingText, SerchpageText, StarList } from "../../ratingStar/ratingStarStyle";
import Full_star from "../../../../assests/images/full-star.svg";
import Half_star from "../../../../assests/images/half-star.svg";
const ManageMyNonprofitStats = ({ setKey }: any) => {
  const [editMailAddressConfirmationOpen, setEditMailAddressConfirmationOpen] =
    useState(false);
  const dispatch: any = useDispatch();
  const location = useLocation();
  const params = useParams();


  const nonprofitStats = useSelector(
    (state: any) => state?.nonprofitStats?.data?.results
  );

  useEffect(() => {
    location?.state?.open === true && setEditMailAddressConfirmationOpen(true);
  }, [location?.state])

  useEffect(() => {
    if (params.tab === "stats") {
      if (params?.id) {
        dispatch(nonprofitStatsHandler(params.id));
      }
      // setEditMailAddressConfirmationOpen(true)
    }
  }, [params]);

  const navigate = useNavigate();
  const marks: SliderSingleProps["marks"] = {
    0: "0",
    10: "10",
    20: "20",
    30: "30",
    40: "40",
    50: "50",
    60: "60",
    70: "70",
    80: "80",
    90: "90",
    100: "100",
  };

  const profileProgress = useMemo(() => {
    if (nonprofitStats) {
      if (!nonprofitStats?.is_address_confirm) {
        setEditMailAddressConfirmationOpen(true);
      }
      const totalTask = Object.keys(nonprofitStats?.profile_status)?.length;
      const totalCompleted = Object.values(
        nonprofitStats?.profile_status
      ).filter((item) => item).length;
      return (totalCompleted * 100) / totalTask;
    }
    return 0;
  }, [nonprofitStats]);


  return (
    <>
      <SectionTitle>
        <Title>{nonprofitStats?.title}</Title>
      </SectionTitle>

      <VoterWatchWrapper>
        <VoterWatchBox>
          <FoundationBox>
            <FoundationImage>
              <Image src={nonprofitStats?.logo ?? NoImage} alt={"logo"} />
            </FoundationImage>
            <FoundationContent>
              <FoundationSubTitle>{MESSAGE.averageRatings}</FoundationSubTitle>
              <RatingHD>
                <SerchpageText>
                  <div className="rating-col">

                    {nonprofitStats?.avg_rating > 0 && <StarList className="rating-star">
                      {[...Array(Math.floor(nonprofitStats?.avg_rating))]?.map((_, index) => (<Image key={index + 1} src={Full_star} className="full-star" alt="rating star" width="15px" height="14px" />
                      ))}
                      {nonprofitStats?.avg_rating % 1 !== 0 && (
                        <Image src={Half_star} className="half-star" alt="rating star" width="15px" height="14px" />
                      )}
                    </StarList>}
                    {nonprofitStats?.reviews > 0 && <CardRatingText className="RatingReview">{nonprofitStats?.reviews} {MESSAGE.reviews}</CardRatingText>}
                  </div>
                </SerchpageText>


              </RatingHD>
              <AddressHere>{nonprofitStats?.address_1}</AddressHere>
            </FoundationContent>
          </FoundationBox>

          <ButtonSection>
            <VoterWatchButton
              className="btn-outline-success-blue"
              onClick={() => navigate(`/dashboard/edit/${params.id}`)}
            >
              {MESSAGE.improveProfile}
            </VoterWatchButton>
            <VoterWatchButton
              className="btn-outline-success-blue"
              onClick={() => navigate(`/dashboard/edit/${params.id}`)}
            >
              {MESSAGE.addPhotos}
            </VoterWatchButton>
            <VoterWatchButton
              className="btn-outline-success-blue "
              onClick={() => navigate(`/dashboard/invite/${params.id}`)}
            >
              {MESSAGE.inviteReviews}
            </VoterWatchButton>
          </ButtonSection>

          <NonprofitsStatsGroup>
            <NonprofitsStats>
              {nonprofitStats?.organizationName} {MESSAGE.nonprofitsStats}
            </NonprofitsStats>
            <NonprofitsStatsText>
              {MESSAGE.latestReviewed}:{" "}
              <NonprofitsStatsSpan>
                {moment(nonprofitStats?.latestReviewDate).format("MMM D, YYYY")}
              </NonprofitsStatsSpan>
            </NonprofitsStatsText>

            <ReviewCounter>
              <ReviewCounterList>
                <ReviewListImage className="rev-list-img-box">
                  <Image src={GreyBox} alt="Grey Box" />
                  <TextSpan>{nonprofitStats?.reviews}</TextSpan>
                </ReviewListImage>
                <ReviewCounterText>{MESSAGE.reviews}</ReviewCounterText>
              </ReviewCounterList>

              <ReviewCounterList>
                <ReviewListImage className="rev-list-img-heart">
                  <Image src={GreyHeart} alt="Grey Heart" />
                  <TextSpan>{nonprofitStats?.followers}</TextSpan>
                </ReviewListImage>
                <ReviewCounterText>{MESSAGE.followers}</ReviewCounterText>
              </ReviewCounterList>

              <ReviewCounterList>
                <ReviewListImage className="rev-list-img-Background">
                  <Image src={GreyBackgroundBox} alt="Grey Background Box" />
                  <TextSpan>{nonprofitStats?.page_views}</TextSpan>
                </ReviewListImage>
                <ReviewCounterText>{MESSAGE.pageViews}</ReviewCounterText>
              </ReviewCounterList>
            </ReviewCounter>
          </NonprofitsStatsGroup>

          <NonprofitsStatsGroup>
            <NonprofitsStats>{MESSAGE.topRatedAwardsStats}</NonprofitsStats>
            <NonprofitsStatsText>Campaign Period to</NonprofitsStatsText>

            <RangeNonprofitStats className="rang-slider-review-pin">
              <Slider
                marks={marks}
                value={nonprofitStats?.no_of_4_star_review}
                step={10}
                tooltip={{ open: false, className: "awards-stats-slider" }}
              />
            </RangeNonprofitStats>
            <ReviewTextNumber>
              <ReviewTextNumberSpan>
                {nonprofitStats?.no_of_4_star_review}
              </ReviewTextNumberSpan>{" "}
              Review
            </ReviewTextNumber>
          </NonprofitsStatsGroup>

          <LinkingText onClick={() => window.open(`${import.meta.env.VITE_CMS_URL}toprated/about-top-rated-awards/`)}>
            {MESSAGE.learnAboutTopRatedAwards}
          </LinkingText>
        </VoterWatchBox>

        <ProfileCompletionBox>
          <NonprofitsStats>{MESSAGE.profileCompletion}</NonprofitsStats>

          <ProfileCompletionProgressBar>
            <Flex wrap gap="small">
              <Progress
                strokeLinecap="butt"
                type="circle"
                percent={profileProgress}
                size={100}
              />
            </Flex>

            <ProfileCompletionCheckBox>
              <Form className="profile-checkbox">
                {["checkbox"].map((type) => (
                  <ProfileCheckboxList
                    key={`inline-${type}`}
                    className="profile-checkbox-list"
                  >
                    <CheckBoxLabelGroup>
                      <Form.Check
                        disabled
                        name="group1"
                        id={`inline-${type}-1`}
                        checked={
                          nonprofitStats?.profile_status?.is_picture_uploaded
                        }
                      />
                      <FormCheckboxText>
                        <FormCheckboxLink
                          onClick={() => {
                            setKey("edit_profile");
                            navigate(`/dashboard/edit/${params.id}`, {
                              state: { sectionId: "media" },
                            });
                          }}
                        >
                          {MESSAGE.uploadPhoto}
                        </FormCheckboxLink>{" "}
                        for your nonprofit
                      </FormCheckboxText>
                    </CheckBoxLabelGroup>

                    <CheckBoxLabelGroup>
                      <Form.Check
                        disabled
                        name="group1"
                        id={`inline-${type}-1`}
                        checked={
                          nonprofitStats?.profile_status
                            ?.is_contact_detail_filled
                        }
                      />
                      <FormCheckboxText>
                        Input your nonprofit's
                        <FormCheckboxLink
                          onClick={() => {
                            navigate(`/dashboard/edit/${params.id}`, {
                              state: { sectionId: "media" },
                            });
                          }}
                        >
                          {" "}
                          Contacts
                        </FormCheckboxLink>
                      </FormCheckboxText>
                    </CheckBoxLabelGroup>

                    <CheckBoxLabelGroup>
                      <Form.Check
                        disabled
                        name="group1"
                        id={`inline-${type}-1`}
                        checked={
                          nonprofitStats?.profile_status?.is_issues_filled
                        }
                      />
                      <FormCheckboxText>
                        Input your nonprofit's
                        <FormCheckboxLink
                          onClick={() => {
                            navigate(`/dashboard/edit/${params.id}`, {
                              state: { sectionId: "media" },
                            });
                          }}
                        >
                          {" "}
                          Issues
                        </FormCheckboxLink>
                      </FormCheckboxText>
                    </CheckBoxLabelGroup>

                    <CheckBoxLabelGroup>
                      <Form.Check
                        disabled
                        name="group1"
                        id={`inline-${type}-1`}
                        checked={
                          nonprofitStats?.profile_status?.is_mission_filled
                        }
                      />
                      <FormCheckboxText>
                        Share your nonprofit's
                        <FormCheckboxLink
                          onClick={() => {
                            navigate(`/dashboard/edit/${params.id}`, {
                              state: { sectionId: "organization" },
                            });
                          }}
                        >
                          {" "}
                          Mission
                        </FormCheckboxLink>
                      </FormCheckboxText>
                    </CheckBoxLabelGroup>

                    <CheckBoxLabelGroup>
                      <Form.Check
                        disabled
                        name="group1"
                        id={`inline-${type}-1`}
                        checked={
                          nonprofitStats?.profile_status?.is_program_filled
                        }
                      />
                      <FormCheckboxText>
                        Share your nonprofit's
                        <FormCheckboxLink
                          onClick={() => {
                            navigate(`/dashboard/edit/${params.id}`, {
                              state: { sectionId: "impact" },
                            });
                          }}
                        >
                          {" "}
                          Programs
                        </FormCheckboxLink>
                      </FormCheckboxText>
                    </CheckBoxLabelGroup>
                  </ProfileCheckboxList>
                ))}
              </Form>
            </ProfileCompletionCheckBox>
          </ProfileCompletionProgressBar>
        </ProfileCompletionBox>
      </VoterWatchWrapper>

      <MailAddressConfirmationModal
        open={editMailAddressConfirmationOpen}
        setOpen={setEditMailAddressConfirmationOpen}
        handleConfirm={() => {
          if (params.id) {
            dispatch(confirmAddressHandler(params.id));
            setEditMailAddressConfirmationOpen(false);
          }
        }}
        handleEdit={() => {
          setEditMailAddressConfirmationOpen(false);
          setKey(`/dashboard/edit/${params.id}`);
        }}

      />
    </>
  );
};
export default ManageMyNonprofitStats;
